<ms-event-switcher-navigation *ngIf="viewModel$ | async as current" [showHeader]="!isEpcotEnabled" [event]="event" [tree]="current">
</ms-event-switcher-navigation>
